import { mapActions, mapState } from 'pinia'
import { loadingMixin } from 'abcreche-ui'
import { useClassroomsStore } from '~~/stores/classrooms.js'

export default {
    mixins: [loadingMixin],

    computed: {
        ...mapState(useClassroomsStore, ['classrooms', 'selectedClassroom', 'classroomFilters']),
        classroomOptions () {
            return this.classrooms.map((classroom) => {
                return {
                    value: classroom.uuid,
                    label: classroom.name
                }
            })
        }
    },

    created () {
        // Please fetch classrooms in the component itself
    },

    methods: {
        ...mapActions(useClassroomsStore, ['fetchClassrooms', 'selectClassroom', 'setClassroomFilter'])
    }
}
